module.exports = __webpack_public_path__ + "img/h5-arrow-left.93d10d9e.png";